<!-- Section Offres par Profil -->
<section class="py-20 px-6 sm:px-8 lg:px-12 xl:px-16 bg-gray-50 min-h-screen">
    <div class="max-w-screen-2xl mx-auto">

        <!-- BLOC D'ERREUR -->
        <div *ngIf="hasError" class="max-w-2xl mx-auto">
            <div class="bg-red-50 border-l-4 border-red-500 rounded-lg p-8 shadow-md">
                <div class="flex items-start">
                    <div class="flex-shrink-0">
                        <svg class="h-12 w-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <div class="ml-4 flex-1">
                        <h3 class="text-2xl font-bold text-red-800 mb-2">
                            Page Non Disponible
                        </h3>
                        <p class="text-red-700 text-lg mb-6">
                            {{ errorMessage }}
                        </p>

                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENU PRINCIPAL - Affiché uniquement si pas d'erreur -->
        <ng-container *ngIf="!hasError">
            <!-- Badge -->
            <div class="text-center mb-8">
                <span class="inline-block px-6 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-medium">
                    Offres {{ getProfileDisplayName() }}
                </span>
            </div>

            <!-- Titre et description -->
            <div class="text-center mb-16">
                <h2 class="text-4xl font-bold text-gray-900 mb-4">
                    Plans d'abonnement pour {{ getProfileDisplayName() }}
                </h2>
                <p class="text-lg text-gray-600">Choisissez l'offre adaptée à vos besoins professionnels</p>
            </div>

            <!-- Loading state -->
            <div *ngIf="isLoadingPlans" class="flex justify-center items-center py-12">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
            </div>

            <!-- Cartes de pricing -->
            <div *ngIf="!isLoadingPlans" class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                <!-- Gratuit (essai) - Statique -->
                <div class="bg-white rounded-lg p-8 shadow-sm border border-gray-200">
                    <h3 class="text-2xl font-bold text-gray-900 mb-2">Essai Gratuit</h3>
                    <p class="text-gray-600 mb-6">Découvrez nos fonctionnalités gratuitement pendant 14 jours</p>

                    <div class="mb-8">
                        <span class="text-4xl font-bold text-gray-900">0 FCFA</span>
                    </div>

                    <div class="space-y-3 mb-8">
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Jusqu'à 3 projets</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Gestion basique des tâches</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Support par email</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">14 jours d'essai</span>
                        </div>
                    </div>

                    <button disabled
                        class="w-full py-3 px-6 border-2 border-gray-300 text-gray-400 mt-6 rounded-lg font-medium cursor-not-allowed opacity-60">
                        Commencer l'essai
                    </button>
                </div>

                <!-- Plan PREMIUM (Dynamique avec animation - Recommandé) -->
                <div *ngIf="currentPremiumPlan" [@planFade]="animationKey"
                    class="bg-white rounded-lg p-8 shadow-lg border-2 border-orange-500 relative">
                    <div class="absolute top-0 right-6 transform -translate-y-1/2">
                        <span class="inline-block px-4 py-1 bg-orange-500 text-white rounded-full text-sm font-medium">
                            Recommandé
                        </span>
                    </div>

                    <!-- Badge du type de plan avec animation -->
                    <div class="flex items-center gap-2 mb-4">
                        <h3 class="text-2xl font-bold text-gray-900">{{ currentPremiumPlan.label }}</h3>
                        <span class="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
                            {{ getCurrentName() }}
                        </span>
                    </div>

                    <p class="text-gray-600 mb-6">{{ truncateDescription(currentPremiumPlan.description) }}</p>

                    <div class="mb-8">
                        <span class="text-4xl font-bold text-gray-900">{{ formatAmount(currentPremiumPlan.totalCost)
                            }}</span>
                        <span class="text-gray-600 ml-2">/ {{ currentPremiumPlan.installmentCount }} mois</span>
                    </div>

                    <div class="space-y-3 mb-8">
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700" *ngIf="currentPremiumPlan.unlimitedProjects">Projets
                                illimités</span>
                            <span class="text-gray-700" *ngIf="!currentPremiumPlan.unlimitedProjects">
                                {{ currentPremiumPlan.projectLimit }} projets maximum
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Gestion avancée des projets</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Support prioritaire 24/7</span>
                        </div>
                        <div class="flex items-center gap-2" *ngIf="currentPremiumPlan.yearlyDiscountRate > 0">
                            <svg class="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Réduction de {{ currentPremiumPlan.yearlyDiscountRate * 100 }}%
                                sur paiement annuel</span>
                        </div>
                    </div>

                    <button (click)="goToSubscription('premium')"
                        class="w-full py-3 px-6 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors shadow-md">
                        Souscrire maintenant
                    </button>
                </div>

                <!-- Placeholder si PREMIUM non disponible -->
                <div *ngIf="!currentPremiumPlan && !isLoadingPlans"
                    class="bg-white rounded-lg p-8 shadow-lg border-2 border-gray-200 relative">
                    <p class="text-center text-gray-500">Plan Premium non disponible pour ce profil</p>
                </div>

                <!-- Plan BASIC (Dynamique avec animation) -->
                <div *ngIf="currentBasicPlan" [@planFade]="animationKey"
                    class="bg-white rounded-lg p-8 shadow-sm border border-gray-200">

                    <!-- Badge du type de plan avec animation -->
                    <div class="flex items-center gap-2 mb-4">
                        <h3 class="text-2xl font-bold text-gray-900">{{ currentBasicPlan.label }}</h3>
                        <span class="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                            Basic
                        </span>
                    </div>

                    <p class="text-gray-600 mb-6">{{ truncateDescription(currentBasicPlan.description) }}</p>

                    <div class="mb-8">
                        <span class="text-4xl font-bold text-gray-900">{{ formatAmount(currentBasicPlan.totalCost)
                            }}</span>
                        <span class="text-gray-600 ml-2">/ {{ currentBasicPlan.installmentCount }} mois</span>
                    </div>

                    <div class="space-y-3 mb-8">
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700" *ngIf="currentBasicPlan.unlimitedProjects">Projets
                                illimités</span>
                            <span class="text-gray-700" *ngIf="!currentBasicPlan.unlimitedProjects">
                                {{ currentBasicPlan.projectLimit }} projets maximum
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Gestion standard des projets</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Support par email</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="text-gray-700">Mises à jour régulières</span>
                        </div>
                    </div>

                    <button (click)="goToSubscription('basic')"
                        class="w-full py-3 px-6 border-2 border-green-500 text-green-500 rounded-lg font-medium hover:bg-green-50 transition-colors">
                        Choisir ce plan
                    </button>
                </div>

                <!-- Placeholder si BASIC non disponible -->
                <div *ngIf="!currentBasicPlan && !isLoadingPlans"
                    class="bg-white rounded-lg p-8 shadow-sm border border-gray-200">
                    <p class="text-center text-gray-500">Plan Basic non disponible pour ce profil</p>
                </div>
            </div>
        </ng-container>
    </div>
</section>